import { LanguagesEnum } from '@/api/enums';

export const resolveDateLocale = (language?: string): string =>
  language ?? LanguagesEnum.EN;
